import React from 'react';
import styled from 'styled-components';
import {onClickCopy} from '../../shared/utility';


const Bottom = styled.div`
    margin-top: 24px;
    font-family: roboto, sans-serif;
    width: 100%;
    > p{
        font-size: 11px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #474646;
        margin: 0 0 12px;
    }
    > div{
        padding: 0 18px 6px;
        border-bottom: 1px solid #9f9f9f;
        font-size: 11px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #9f9f9f;
        position: relative;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        > img{
            position: absolute;
            right: 0;
            cursor: pointer;
        }
    }
`

export const Address = ({address}) => {
    return (
        <Bottom>
            <p>Address</p>
            <div>
                {address}
                <img src={require("../../images/copy-icon.png")} onClick={(e) => onClickCopy(e, address)} alt="copy"/>
            </div>
        </Bottom>
    )
}